import { APP_DISCLAIMER_TYPES } from 'app-constants';
import c from 'clsx';
import { useRootContext } from 'context/root';
import type { ReactNode } from 'react';

import styles from './AppDisclaimer.module.scss';

type AppDisclaimerProps = {
  visible?: boolean;
  title: ReactNode;
  withNoTopMargin?: boolean;
  withSmallTopMargin?: boolean;
  type: string;
  className?: string;
};

const AppDisclaimer = ({
  visible,
  title,
  withNoTopMargin,
  withSmallTopMargin,
  type = APP_DISCLAIMER_TYPES.primary,
  className,
}: AppDisclaimerProps) => {
  const { applicationPrivateInfo } = useRootContext();
  const { is_test } = applicationPrivateInfo ?? {};

  if (!visible) return null;

  return (
    <div
      className={c(styles.disclaimer, className, {
        [styles['disclaimer--warning']]: type === APP_DISCLAIMER_TYPES.warning,
        [styles['disclaimer--error']]: type === APP_DISCLAIMER_TYPES.error,
        [styles['disclaimer--with-no-top-margin']]: !is_test && withNoTopMargin,
        [styles.margin__top_20]: !is_test && withSmallTopMargin,
      })}
    >
      <div className={styles.disclaimer__title}>{title}</div>
    </div>
  );
};

export default AppDisclaimer;
